"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DelegationRequest = void 0;
var DelegationRequest = /** @class */ (function () {
    function DelegationRequest() {
    }
    return DelegationRequest;
}());
exports.DelegationRequest = DelegationRequest;
;
//# sourceMappingURL=delegation.request.js.map